import { type Image3DType, Info, type UserAgreementRequirementConfig, type UserRequirement } from '@capsicum/common';
import { Image, Image3D } from '@capsicum/common-web';
import styled from 'styled-components';

// We need to keep the old images for backward compatibility
const oldImages: Record<string, Image3DType> = {
	ankward: 'warning',
	celebration: 'confirmation',
	surprise: 'quizSuccess'
};

export const useGenericAgreementImages = (requirement: UserRequirement) => {
	const { confirmImage, declineImage, image } = requirement.config as UserAgreementRequirementConfig;

	return {
		confirmImage: confirmImage ? (
			<Image3D
				image={oldImages[confirmImage as keyof typeof oldImages] || (confirmImage as Image3DType)}
				testID={confirmImage}
			/>
		) : (
			<S.InfoImage alt="Info" height={200} src={Info} width={200} />
		),
		declineImage: declineImage ? (
			<Image3D
				image={oldImages[declineImage as keyof typeof oldImages] || (declineImage as Image3DType)}
				testID={declineImage}
			/>
		) : (
			<S.InfoImage alt="Info" height={200} src={Info} width={200} />
		),
		image: image ? (
			<Image3D image={oldImages[image as keyof typeof oldImages] || (image as Image3DType)} testID={image} />
		) : (
			<S.InfoImage alt="Info" height={200} src={Info} width={200} />
		)
	};
};

namespace S {
	export const InfoImage = styled(Image)`
		margin: 0 auto;
	`;
}
